import { numericalPwPluginVersion } from './parseVersion';
/**
 * Loads the PW server info from local storage for the given datasource URL.
 * @internal
 */
export function loadServerInfoFromStorage(datasourceUrl) {
    try {
        const cachedValue = localStorage.getItem('PWServerInfo');
        if (!cachedValue) {
            return null;
        }
        const serverInfo = JSON.parse(cachedValue);
        const datasourceInfo = serverInfo[datasourceUrl];
        if (!(datasourceInfo === null || datasourceInfo === void 0 ? void 0 : datasourceInfo.pwPluginVersion) ||
            !(datasourceInfo === null || datasourceInfo === void 0 ? void 0 : datasourceInfo.webApiVersion) ||
            !(datasourceInfo === null || datasourceInfo === void 0 ? void 0 : datasourceInfo.wsgVersion)) {
            return null;
        }
        return datasourceInfo;
    }
    catch {
        return null;
    }
}
/**
 * Saves the PW server info to local storage for the given datasource URL.
 * @internal
 */
export function saveServerInfoToStorage(datasourceUrl, pluginInfo) {
    const cachedValue = localStorage.getItem('PWServerInfo');
    const serverInfo = cachedValue
        ? JSON.parse(cachedValue)
        : {};
    serverInfo[datasourceUrl] = pluginInfo;
    localStorage.setItem('PWServerInfo', JSON.stringify(serverInfo));
}
/**
 * Retrieves the PW Plugin version from local storage for the given datasource URL.
 * Assists in workaround for older plugin versions
 * https://dev.azure.com/bentleycs/beconnect/_workitems/edit/979885
 * @param datasourceUrl ProjectWise datasource URL
 * @returns PW Plugin version as a number
 */
export function getCachedPWPluginVersion(datasourceUrl) {
    try {
        const cachedValue = localStorage.getItem('PWServerInfo');
        if (!cachedValue) {
            return 0;
        }
        const serverInfo = JSON.parse(cachedValue);
        const datasourceInfo = serverInfo[datasourceUrl];
        if (!datasourceInfo) {
            return 0;
        }
        return numericalPwPluginVersion(datasourceInfo.pwPluginVersion);
    }
    catch {
        return 0;
    }
}
